import {IUserRoles} from '../interfaces'

export enum RoleNameEnum {
  Admin = 'Admin',
  EvaluationsandCredits = 'EvaluationsandCredits',
  Financial = 'Financial',
  User = 'User',
  Management = 'Management',
  Official = 'Official',
  LegalAdmin = 'LegalAdmin',
  InvestmentUnit = 'InvestmentUnit',
  Warranty = 'Warranty',
  Board = 'Board',
}

export const isValidRole = (roleList: IUserRoles[], roleName: RoleNameEnum) => {
  return roleList.some((role) => role.role.normalizedName === roleName)
}

export enum ValidRoleForInquiryEnum {
  Admin = 'Admin',
  EvaluationsandCredits = 'EvaluationsandCredits',
  Financial = 'Financial',
  Warranty = 'Warranty',
}

export const isValidRoleForInquiry = (roleList: IUserRoles[]): boolean => {
  return roleList.some((role) =>
    Object.values(ValidRoleForInquiryEnum).includes(
      role.role.normalizedName as ValidRoleForInquiryEnum
    )
  )
}
